import {useQuery} from "react-query";
import {QuicksightService} from "../../../services/QuicksightService";

export const useQuicksightAdminDashboards = () =>
  useQuery("quicksightAdminDashboards", async () => {
    const {data} = await QuicksightService.getAdminDashboards();

    return data.dashboards;
  });
